import React, { useState } from "react";
import "./form.scss";
import axios from "axios";
import { useStateValue } from "../../context/StateProvider";
import CheckoutV2 from "./CheckoutV2";
import { FiArrowLeft } from "react-icons/fi";

const Form = ({ setCartMode }) => {
  const [{ cart }, dispatch] = useStateValue();
  const [formData, setFormData] = useState({
    Email: "",
    "Postal Code": "",
    "First Name": "",
    "Last Name": "",
    Address: "",
    Apartment: "",
    City: "",
    Province: "",
    "Phone Number": "",
  });
  const [formError, setFormError] = useState("");
  const [mode, setMode] = useState("edit");

  const handleForm = (e) => {
    setFormError("");
    const toUpdate = { [e.target.name]: e.target.value };
    setFormData({ ...formData, ...toUpdate });
  };

  const validateForm = () => {
    for (const field in formData) {
      if (formData[field] === "" && field !== "Apartment") {
        setFormError(`${field} is required`);
        return false;
      }
    }
    setMode("review");
  };
  const handlePayment = () => {
    setMode("payment");
  };

  return (
    <div className="delivery-form">
      <button
        className="go-back-cart-btn"
        onClick={() => setCartMode("cart-items")}
      >
        {" "}
        <FiArrowLeft /> Back to Cart
      </button>
      <p className="delivery-form-title">
        {mode === "edit" ? "Delivery Information" : "Review"}
      </p>

      <span className="">
        {" "}
        {mode === "edit"
          ? "*Deliveries only available for GTA"
          : "Please review your details below"}
      </span>

      <p className="delivery-instructions">
        {mode === "edit" ? (
          <div>
            If this is a gift please enter your own email and the receiver's
            delivery information.
            <br />
            If you have multiple destinations enter your own information and
            contact us.
          </div>
        ) : (
          ""
        )}
      </p>

      {mode === "edit" && (
        <>
          <div className="form">
            <div className="form-row email">
              <input
                type="text"
                name="Email"
                placeholder=" Your Email"
                value={formData["Email"]}
                onChange={handleForm}
              />
            </div>
            <div className="form-row delivery-names">
              <input
                type="text"
                name="First Name"
                placeholder="First Name"
                value={formData["First Name"]}
                onChange={handleForm}
              />
              <input
                type="text"
                name="Last Name"
                placeholder="Last Name"
                value={formData["Last Name"]}
                onChange={handleForm}
              />
            </div>
            <div className="form-row">
              <input
                type="text"
                name="Address"
                placeholder="Street Address"
                value={formData["Address"]}
                style={{ width: "100%" }}
                onChange={handleForm}
              />
            </div>
            <div className="form-row">
              <input
                type="text"
                name="Apartment"
                value={formData["Apartment"]}
                placeholder="Apartment/suite/etc (optional)"
                style={{ width: "100%" }}
                onChange={handleForm}
              />
            </div>
            <div className="form-row city-province">
              <input
                type="text"
                name="City"
                value={formData["City"]}
                placeholder="City"
                onChange={handleForm}
              />
              <input
                type="text"
                name="Province"
                value={formData["Province"]}
                placeholder="Province"
                onChange={handleForm}
              />
              <input
                type="text"
                name="Postal Code"
                value={formData["Postal Code"]}
                placeholder="Postal Code"
                onChange={handleForm}
              />
            </div>
            <div className="form-row">
              <input
                type="text"
                name="Phone Number"
                placeholder="Phone Number"
                style={{ width: "100%" }}
                onChange={handleForm}
                value={formData["Phone Number"]}
              />
            </div>
            <div className="form-row">
              <button className="button" onClick={validateForm}>
                <span>Submit</span>
              </button>
            </div>
            {formError && (
              <div className="form-row">
                <p style={{ color: "red" }}>*{formError}</p>
              </div>
            )}
          </div>
        </>
      )}
      {mode === "review" && (
        <section className="review-shipping">
          <p>{formData["Email"]}</p>
          <div className="first-last-shipping">
            <p>{formData["First Name"]}</p>
            <p>{formData["Last Name"]}</p>
          </div>
          <div className="apt-address-shipping">
            <p>{formData["Address"]}</p>
            {formData["Apartment"] && <p>{formData["Apartment"]}</p>}
          </div>
          <div className="city-province-shipping">
            <p>{formData["City"]},</p>
            <p>{formData["Province"]}</p>
          </div>
          <p>{formData["Postal Code"]}</p>
          <p>{formData["Phone Number"]}</p>
          <div className="info-review-btns">
            <button
              className="button is-warning"
              onClick={() => setMode("edit")}
            >
              <span>Edit your Info</span>
            </button>
            <CheckoutV2 formData={formData} />
          </div>
        </section>
      )}
    </div>
  );
};

export default Form;
